module.exports = __webpack_public_path__ + "71c4baede7bc7924a13e1d2ca1d43fac.pdf";